// Threre's about 190'ish countries (UN and non-UN) that we'd have to worry about
// so this should cover that.
export const COUNTRY_FILTER_LIMIT = 200;
